import { Box, Typography } from "@mui/material";
import CheckIcon from "@mui/icons-material/Check";

export default function ComparisonBox({ data }) {
  return (
    <Box
      sx={{
        width: {
          xs: "100%",
          sm: "100%",
          md: 624,
        },
        maxWidth: 624,
        borderRadius: "16px",
        overflow: "hidden",

        background: "linear-gradient(180deg, #EBE9FF 0%, #C6BEFF 100%)",

        display: "flex",
        flexDirection: {
          xs: "column",
          md: "row",
        },
        justifyContent: {
          xs: "center",
          sm: "center",
          md: "flex-end",
        },
      }}
    >
      {/* LEFT - DAM Journey */}
      <Box
        sx={{
          flex: 1,
          background: "linear-gradient(180deg,#3853BB 0%,#39368C 100%)",
          color: "#fff",
          display: "flex",
          flexDirection: "column",
          borderRadius: "16px",
        }}
      >
        {/* Header */}
        <Typography
          variant="h5"
          sx={{
            minHeight: 64,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            fontWeight: 600,
          }}
        >
          DAM Journey
        </Typography>

        {/* List */}
        {data.map((item, i) => (
          <Box
            key={i}
            sx={{
              minHeight: 56,
              px: 3,
              py: 2,
              display: "flex",
              alignItems: "center",
              gap: 2,
              backgroundColor: "rgba(0,0,0,0.05)", // #00000008
            }}
          >
            <CheckIcon sx={{ color: "#FFD54F" }} />
            <Typography>{item.left}</Typography>
          </Box>
        ))}
      </Box>

      {/* RIGHT - Others */}
      <Box
        sx={{
          flex: 1,
          background: "linear-gradient(180deg,#EBE9FF 0%,#C6BEFF 100%)",
          display: "flex",
          flexDirection: "column",
        }}
      >
        {/* Header */}
        <Typography
          variant="h5"
          sx={{
            minHeight: 64,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            fontWeight: 600,
            color: "#2b2e83",
          }}
        >
          Others
        </Typography>

        {/* List */}
        {data.map((item, i) => (
          <Box
            key={i}
            sx={{
              minHeight: 56,
              px: 3,
              py: 2,
              display: "flex",
              alignItems: "center",
              gap: 2,
              backgroundColor: i % 2 === 0 ? "rgba(255,255,255,0.3)" : "rgba(0,0,0,0.05)",
            }}
          >
            <Typography color="#2b2e83">{item.right}</Typography>
          </Box>
        ))}
      </Box>
    </Box>
  );
}
